var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { StepType } from "@types";
import { findSourceById, getSelectedStepDetailsById, handleStepFieldValueChanges, registerStep, validateFieldConfiguration, validateSource, validateStep, validateStepNameAndId } from "@utils";
import { FormSection } from "@components/FormSection/FormSection";
import { SourceSelectorInput } from "../SourceSelector/SourceSelectorInput";
import Icon from '@images/select.svg';
import { FieldMapper } from "../FieldMapper/FieldMapper";
export function renderStep(context, query, onChange, selectedStepId) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId);
    const _step = Object.assign({}, step);
    const $L = (key) => context.uxpContext.$L(key);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        const { isValid, errors } = validateStep(query, step);
        const resolved = Object.fromEntries(Object.entries(errors || {}).map(([k, v]) => [k, v && v.startsWith('lqe.') ? $L(v) : v]));
        setErrors(resolved);
    }, [step]);
    const source = findSourceById(query, _step === null || _step === void 0 ? void 0 : _step.source);
    function onValueChange(field, value, source) {
        return __awaiter(this, void 0, void 0, function* () {
            const _query = yield handleStepFieldValueChanges(context, query, selectedStepId, field, value, source);
            onChange(_query);
        });
    }
    return React.createElement(React.Fragment, null,
        React.createElement(FormSection, { label: $L('lqe.step.select.source'), error: errors === null || errors === void 0 ? void 0 : errors.source },
            React.createElement(SourceSelectorInput, { source: source, onChange: newSource => {
                    onValueChange('source', newSource, true);
                }, availableSources: [...previousSteps, ...selectedSources], query: query })),
        React.createElement(FormSection, { label: $L('lqe.step.select.fields'), error: errors === null || errors === void 0 ? void 0 : errors.include },
            React.createElement(FieldMapper, { fields: ((_step === null || _step === void 0 ? void 0 : _step.include) || []).map(f => ({
                    field: f,
                    newField: ''
                })), source: source, onChange: fields => onValueChange('include', fields.map(f => f.field)), disableRename: true })));
}
function validate(query, step) {
    var _a;
    const errors = validateStepNameAndId(step);
    // validate source
    const source = validateSource(query, step, 'source');
    if (!source.isValid)
        errors.source = source.error;
    if (!(step === null || step === void 0 ? void 0 : step.include) || ((_a = step === null || step === void 0 ? void 0 : step.include) === null || _a === void 0 ? void 0 : _a.length) == 0)
        errors.include = 'lqe.step.select.error-no-fields';
    else {
        const fields = validateFieldConfiguration(query, step, (step === null || step === void 0 ? void 0 : step.include) || [], 'source');
        if (!fields.isValid)
            errors.include = fields.error;
    }
    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
}
registerStep({
    type: StepType.Select,
    name: "lqe.step.select.name",
    description: "lqe.step.select.description",
    icon: Icon,
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return Object.assign(Object.assign({}, basicProps), { source: previousSource, include: [] });
    }
});
